/** Clé sessionStorage pour le site clinique (infirmier, médecin). */
export const CLINICAL_WORK_SITE_SESSION_KEY = 'funtoa_clinical_work_site_id';
